"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UssVodUploader = void 0;
var axios_1 = require("axios");
var md5_1 = require("./md5");
var types_1 = require("./types");
var UssVodUploader = /** @class */ (function () {
    function UssVodUploader(_a) {
        var _this = this;
        var mediaFile = _a.mediaFile, coverFile = _a.coverFile, uss = _a.uss, cancelToken = _a.cancelToken, mediaType = _a.mediaType, autoPicType = _a.autoPicType, report = _a.report;
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.eventMap = new Map();
        this.report = report;
        this.cancel = function () { return uss.cancel(cancelToken); };
        this.resume = function () { return uss.resume(cancelToken); };
        var promises = [
            Promise.resolve(null),
            Promise.resolve(null),
            Promise.resolve(null),
            Promise.resolve(null)
        ];
        if (mediaFile) {
            this.fsize = mediaFile.size;
            promises[0] = uss
                .putObject({
                file: mediaFile,
                contentType: mediaType == types_1.MediaType.video
                    ? types_1.ContentType.video
                    : types_1.ContentType.audio,
                cancelToken: cancelToken,
                onUploadProgress: function (event) {
                    _this.emit(types_1.UploaderEvents.mediaProgress, event);
                }
            })
                .then(function (res) {
                var normalizeResponse = _this.getNormalizeResponse(res);
                _this.emit(types_1.UploaderEvents.mediaUpload, normalizeResponse);
                return normalizeResponse;
            })
                .catch(function (error) {
                var _a, _b, _c, _d, _e, _f, _g;
                var actionId = types_1.ErrorCode.PublishResultVideoFailed;
                if (axios_1.default.isCancel((error === null || error === void 0 ? void 0 : error.error) || error))
                    actionId = types_1.ErrorCode.UserCancel;
                (_a = _this.report) === null || _a === void 0 ? void 0 : _a.FileTransferEvent({
                    actionId: actionId,
                    code: (_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : 0,
                    sdkCode: (_g = (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.code) !== null && _g !== void 0 ? _g : 0
                }).report();
                _this.cancel();
                throw error;
            });
            promises[2] = new Promise(function (resolve, reject) {
                md5_1.getFileMd5(mediaFile).then(resolve).catch(reject);
            });
        }
        if (coverFile) {
            if (!mediaFile)
                this.fsize = coverFile.size;
            promises[1] = uss
                .putObject({
                file: coverFile,
                contentType: types_1.ContentType.image,
                cancelToken: cancelToken,
                onUploadProgress: function (event) {
                    _this.emit(types_1.UploaderEvents.coverProgress, event);
                },
                autoPicType: autoPicType
            })
                .then(function (res) {
                var normalizeResponse = _this.getNormalizeResponse(res);
                _this.emit(types_1.UploaderEvents.coverUpload, normalizeResponse);
                return normalizeResponse;
            })
                .catch(function (error) {
                var _a, _b, _c, _d, _e, _f, _g;
                var actionId = types_1.ErrorCode.PublishResultCoverFailed;
                if (axios_1.default.isCancel((error === null || error === void 0 ? void 0 : error.error) || error))
                    actionId = types_1.ErrorCode.UserCancel;
                (_a = _this.report) === null || _a === void 0 ? void 0 : _a.FileTransferEvent({
                    actionId: actionId,
                    code: (_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : 0,
                    sdkCode: (_g = (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.code) !== null && _g !== void 0 ? _g : 0
                }).report();
                _this.cancel();
                throw error;
            });
            promises[3] = new Promise(function (resolve, reject) {
                md5_1.getFileMd5(coverFile).then(resolve).catch(reject);
            });
        }
        // @ts-ignore
        this.donePromise = Promise.all(promises);
    }
    UssVodUploader.prototype.done = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var startTime, _b, video, cover, videoMd5, coverMd5, result, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        startTime = Date.now();
                        return [4 /*yield*/, this.donePromise];
                    case 1:
                        _b = _c.sent(), video = _b[0], cover = _b[1], videoMd5 = _b[2], coverMd5 = _b[3];
                        (_a = this.report) === null || _a === void 0 ? void 0 : _a.FileTransferEvent({
                            actionId: types_1.ErrorCode.Success,
                            code: 0,
                            sdkCode: 0,
                            cost: Date.now() - startTime,
                            extendId: (video === null || video === void 0 ? void 0 : video.extendId) || (cover === null || cover === void 0 ? void 0 : cover.extendId),
                            fsize: this.fsize
                        }).report();
                        result = {
                            video: video,
                            cover: cover
                        };
                        if (videoMd5) {
                            result.video.md5 = videoMd5;
                        }
                        if (coverMd5) {
                            result.cover.md5 = coverMd5;
                        }
                        return [2 /*return*/, result];
                    case 2:
                        error_1 = _c.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    UssVodUploader.prototype.on = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName) || new Set();
        callbacks.add(callback);
        this.eventMap.set(eventName, callbacks);
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    UssVodUploader.prototype.off = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.delete(callback);
            if (callbacks.size === 0) {
                this.eventMap.delete(eventName);
            }
        }
    };
    UssVodUploader.prototype.getNormalizeResponse = function (res) {
        return {
            url: res.url,
            etag: res.etag,
            extendId: res.fid
        };
    };
    UssVodUploader.prototype.emit = function (eventName, params) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.forEach(function (callback) {
                callback(params);
            });
        }
    };
    return UssVodUploader;
}());
exports.UssVodUploader = UssVodUploader;
